export default __webpack_public_path__ + "static/media/brief-1.03a70b95.webp";